import React, { Component } from "react";
import { Navigate, Link } from "react-router-dom";

import CartContext from "./CartContext";
import ElasticCartAd from "./ElasticCartAd";

/* react-bootstrap */
import {
  Alert,
  Row,
  Col,
  Nav,
  Table,
  Badge,
  ListGroup,
  Accordion,
  Button,
} from "react-bootstrap";

/* react-icons grouped by package (duplicates removed) */
import {
  SiHackthebox,
  SiDatabricks,
  SiCoinmarketcap,
  SiCommerzbank,
} from "react-icons/si";

import {
  TbReportAnalytics,
  TbPackage,
  TbReceiptTax,
  TbBuildingStore,
  TbPackages,
} from "react-icons/tb";

import { RiFeedbackLine, RiCoupon5Line } from "react-icons/ri";

import {
  BsUiChecksGrid,
  BsZoomOut,
  BsFillCartCheckFill,
  BsFillPeopleFill,
  BsPeopleFill,
  BsFillBagFill,
  BsFullscreen,
  BsTruck,
  BsCashCoin,
  BsDoorClosed,
  BsClockHistory,
  BsArrowReturnLeft,
  BsDiagram3,
  BsPersonSquare,
  BsPersonCheckFill,
  BsFillCameraFill,
  BsFillFileImageFill,
  BsFillLaptopFill,
  BsAward,
  BsMenuDown,
  BsCardList,
  BsBoundingBox,
  BsArrowRight,
} from "react-icons/bs";

import { TiCloudStorage } from "react-icons/ti";
import { MdSoupKitchen, MdDashboard } from "react-icons/md";
import { GoListOrdered } from "react-icons/go";

import {
  FaHouseDamage,
  FaBuysellads,
  FaTags,
  FaProjectDiagram,
} from "react-icons/fa";

import { FiUsers } from "react-icons/fi";
import { FaUsers, FaMoneyBillTrendUp } from "react-icons/fa6";

import { PiListNumbersFill } from "react-icons/pi";
import {
  BiSolidQuoteRight,
  BiBarChart,
  BiSolidPurchaseTag,
} from "react-icons/bi";
import { LiaFirstOrder } from "react-icons/lia";

import {
  FcSelfServiceKiosk,
  FcWorkflow,
  FcSalesPerformance,
} from "react-icons/fc";
import { GrServices } from "react-icons/gr";

export default class HomeMobileFront extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      showElasticCart: true,
      // track which accordions were opened if you want later
      productDefaultActiveKey: "0",
      salesDefaultActiveKey: "0",
      ordersDefaultActiveKey: "0",
    };
  }

  showMainDashboard = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showMainReports = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };

  showSuppliers = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.PRODUCTPURCHASEMANAGER ==
        this.context.userData.roleId ||
      this.context.UserRoles.RAWMATERIALSINVENTORYMANAGER ==
        this.context.userData.roleId ||
      this.context.UserRoles.SUPPLIER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showWarehouse = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };

  showRmInventory = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.RAWMATERIALSINVENTORYMANAGER ==
        this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showManufacturer = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.RAWMATERIALSINVENTORYMANAGER ==
        this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showProductInventory = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.CRMSALEEXECUTIVE == this.context.userData.roleId ||
      this.context.UserRoles.CRMMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.PRODUCTPURCHASEMANAGER ==
        this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showServicing = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.SERVICINGMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showMarketing = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.CRMMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.CRMSALEEXECUTIVE == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showSales = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.ORDERS == this.context.userData.roleId ||
      this.context.UserRoles.CRMMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.CRMSALEEXECUTIVE == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };

  showCrm = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      // this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      // this.context.UserRoles.ORDERS == this.context.userData.roleId ||
      this.context.UserRoles.CRMMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.CRMSALEEXECUTIVE == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showHrm = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.HRMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showProjects = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.HRMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.PROJECTMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  showAccounts = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.ACCOUNTINGMANAGER ==
        this.context.userData.roleId ||
      this.context.UserRoles.ACCOUNTINGEMPLOYEE == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };

  showOrders = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.ORDERS == this.context.userData.roleId ||
      this.context.UserRoles.CRMMANAGER == this.context.userData.roleId ||
      this.context.UserRoles.CRMSALEEXECUTIVE == this.context.userData.roleId ||
      this.context.UserRoles.ORDERS == this.context.userData.roleId ||
      this.context.UserRoles.PACKAGING == this.context.userData.roleId ||
      this.context.UserRoles.DELIVERY == this.context.userData.roleId ||
      this.context.UserRoles.PAYMENT == this.context.userData.roleId ||
      this.context.UserRoles.RETURNS == this.context.userData.roleId ||
      this.context.UserRoles.SHIPPING == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };

  enablePortalSettingsMenu = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  ShowStorage = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId ||
      this.context.UserRoles.BUSINESSMANAGER == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  ShowAdminMenu = () => {
    if (
      this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId ||
      this.context.UserRoles.SUPERADMIN == this.context.userData.roleId
    ) {
      return true;
    } else {
      return false;
    }
  };
  ShowProductAdminMenu = () => {
    if (this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId) {
      return true;
    } else {
      return false;
    }
  };

  fakeRequest1 = () => {
    return new Promise((resolve) => setTimeout(() => resolve(), 2000));
  };

  CleanupOldCustomerOrders = async () => {
    if (!this.context.storeId) return;

    const url = `${process.env.REACT_APP_API}StoreManager/DeleteOldCustomerOrders/${this.context.storeId}/2`;
    try {
      await fetch(url, { method: "DELETE" });
    } catch (err) {
      console.error("DeleteOldCustomerOrders failed:", err);
    }
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.context.prods && this.context.prods.length == 0) {
      this.fakeRequest1().then(() => {
        this.setState({ showElasticCart: false });
      });
    } else {
      this.setState({ showElasticCart: false });
    }

    this.CleanupOldCustomerOrders();

    // guard method calls in case methods are defined elsewhere / mixed in
    if (
      (this.state.dashboardSummary === "" ||
        this.state.dashboardSummary === undefined) &&
      this.context.storeId != ""
    ) {
      if (typeof this.GetDashboardSummary === "function")
        this.GetDashboardSummary();
      if (typeof this.GetOrderSummary === "function") this.GetOrderSummary();
      if (typeof this.GetRevenueSummary === "function")
        this.GetRevenueSummary();
      if (typeof this.GetCustomerSummary === "function")
        this.GetCustomerSummary();
      if (typeof this.GetTopSellingProductsSummary === "function")
        this.GetTopSellingProductsSummary();
    }
  }

  render() {
    // show ElasticCart ad while loading initial data
    if (this.state.showElasticCart === true) {
      return <ElasticCartAd />;
    }

    // redirect to login if not active
    if (
      this.context.userData &&
      this.context.userData.loginStatus != "active"
    ) {
      return <Navigate to="/UserLogin" />;
    }

    return (
      <>
        <div className="py-1 mainthemecolor">
          <div className="p-1 py-2 mx-1 mb-5">
            <Table hover className="p-0 m-0" size="sm">
              <tbody className="text-start p-0 m-0">
                {/* Dashboard */}
                {this.showMainDashboard() ? (
                  <>
                    <ListGroup.Item>
                      <Nav.Link
                        as={Link}
                        className="w-100 py-2 fs-3"
                        to="/HomeDashboard"
                        onClick={(e) => {
                          this.context.selectedMenuItem = "dashboard";
                        }}
                      >
                        <MdDashboard size={20} />
                        &nbsp;Dashboard
                      </Nav.Link>
                    </ListGroup.Item>
                  </>
                ) : (
                  <></>
                )}

                {/* Reports */}
                {this.showMainReports() ? (
                  <>
                    <ListGroup.Item>
                      <Nav.Link
                        as={Link}
                        className="w-100 py-2 fs-3"
                        to="/Reports"
                      >
                        <TbReportAnalytics size="22" />
                        &nbsp;Reports
                      </Nav.Link>
                    </ListGroup.Item>
                  </>
                ) : (
                  <></>
                )}

                {/* Warehouse */}
                {this.showWarehouse() ? (
                  <>
                    <ListGroup.Item>
                      <Nav.Link
                        as={Link}
                        className="w-100 py-2 fs-3"
                        to="/Warehouse"
                      >
                        <FaHouseDamage size="20" />
                        &nbsp;Warehouses
                      </Nav.Link>
                    </ListGroup.Item>
                  </>
                ) : (
                  <></>
                )}

                {/* Suppliers */}
                {this.showSuppliers() ? (
                  <>
                    <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                      <Accordion
                        defaultActiveKey="1"
                        className="m-0 p-0 border-0"
                      >
                        <Accordion.Item
                          eventKey={
                            this.context.selectedMenuItem === "Suppliers"
                              ? "1"
                              : "0"
                          }
                          className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                          onClick={(e) => {
                            this.context.selectedMenuItem = "Suppliers";
                          }}
                        >
                          <Accordion.Header className="py-2  text-start">
                            <Nav.Link as={Link} className="m-0 p-0 fs-3 " to="">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-boxes"
                                viewBox="0 0 16 16"
                              >
                                <path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434zM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567zM7.5 9.933l-2.75 1.571v3.134l2.75-1.571zm1 3.134 2.75 1.571v-3.134L8.5 9.933zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567zm2.242-2.433V3.504L8.5 5.076V8.21zM7.5 8.21V5.076L4.75 3.504v3.134zM5.258 2.643 8 4.21l2.742-1.567L8 1.076zM15 9.933l-2.75 1.571v3.134L15 13.067zM3.75 14.638v-3.134L1 9.933v3.134z" />
                              </svg>
                              {this.context.store.businessTypeId == 3 ? (
                                <>&nbsp;Suppliers </>
                              ) : (
                                <>&nbsp;Suppliers </>
                              )}
                            </Nav.Link>
                          </Accordion.Header>
                          <Accordion.Body>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                              <Nav.Link
                                as={Link}
                                className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                                to="/Suppliers"
                              >
                                <FiUsers size={20} />
                                &nbsp; Suppliers
                              </Nav.Link>
                            </ListGroup.Item>
                            {this.context.storeSettings
                              .showSuppliersManagement == true ? (
                              <>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                  <Nav.Link
                                    as={Link}
                                    className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                                    to="/SupplierInventory"
                                  >
                                    <BsUiChecksGrid size="20" />
                                    &nbsp; Inventory
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                  <Nav.Link
                                    as={Link}
                                    className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                                    to="/SupplierPurchaseOrdersIndent"
                                  >
                                    <PiListNumbersFill size="20" />
                                    &nbsp; PO Received
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                  <Nav.Link
                                    as={Link}
                                    className="w-100 py-1 mx-0 my-0 mb-0 bg-white border-0 text-dark text-start menuNav.Link"
                                    to="/SupplierPurchaseOrderInward"
                                  >
                                    <BsTruck size="20" />
                                    &nbsp; PO Delivered
                                  </Nav.Link>
                                </ListGroup.Item>
                              </>
                            ) : (
                              <></>
                            )}
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </ListGroup.Item>
                  </>
                ) : (
                  <></>
                )}

                {/* Orders */}
                {this.showOrders() ? (
                  <>
                    <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                      <Accordion
                        defaultActiveKey="0"
                        className="m-0 p-0 border-0"
                      >
                        <Accordion.Item
                          eventKey={
                            this.context.selectedMenuItem === "orders"
                              ? "1"
                              : "0"
                          }
                          className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                          onClick={(e) => {
                            this.context.selectedMenuItem = "orders";
                          }}
                        >
                          <Accordion.Header className="py-2  text-start">
                            <Nav.Link
                              to=""
                              className="m-0 p-0 fs-3 "
                              hidden={this.context.hideOrderToolbarIcon()}
                            >
                              <LiaFirstOrder size="20" />
                              &nbsp;Orders
                            </Nav.Link>
                          </Accordion.Header>
                          <Accordion.Body>
                            <ListGroup.Item>
                              <Nav.Link
                                as={Link}
                                to="/OrdersDashboard"
                                onClick={(e) => {
                                  this.context.selectedMenuItem = "dashboard";
                                }}
                                hidden={this.context.hideNewOrders()}
                              >
                                <BiBarChart size={20}></BiBarChart>
                                &nbsp;Dashboard
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item>
                              <Nav.Link
                                as={Link}
                                to="/Orders"
                                hidden={this.context.hideNewOrders()}
                              >
                                <Row>
                                  <Col>1. New Orders</Col>
                                  <Col className="text-end">
                                    <GoListOrdered size="20" />
                                    <Badge
                                      bg="primary"
                                      className="notify-badge-right1 text-white"
                                    >
                                      {this.context.orderSummary != ""
                                        ? this.context.orderSummary
                                            .orderReceived
                                        : ""}
                                    </Badge>
                                  </Col>
                                </Row>
                              </Nav.Link>
                            </ListGroup.Item>

                            {this.context.store.businessTypeId == 3 ? (
                              <>
                                <ListGroup.Item>
                                  <Nav.Link
                                    as={Link}
                                    to="/Kds2"
                                    hidden={this.context.hidePackaingToolbarIcon()}
                                  >
                                    <Row>
                                      <Col>2. Prepare</Col>
                                      <Col className="text-end">
                                        <BsFullscreen size="20"></BsFullscreen>
                                        <Badge
                                          bg="success"
                                          className="notify-badge-right1 text-white"
                                        >
                                          {this.context.orderSummary != ""
                                            ? this.context.orderSummary
                                                .orderPrepare
                                            : ""}
                                        </Badge>
                                      </Col>
                                    </Row>
                                  </Nav.Link>
                                </ListGroup.Item>
                              </>
                            ) : (
                              <>
                                <ListGroup.Item>
                                  <Nav.Link
                                    as={Link}
                                    to="/Kds2"
                                    hidden={this.context.hidePackaingToolbarIcon()}
                                  >
                                    <Row>
                                      <Col>2. Prepare</Col>
                                      <Col className="text-end">
                                        <BsFullscreen size="20"></BsFullscreen>
                                        <Badge
                                          bg="success"
                                          className="notify-badge-right1 text-white"
                                        >
                                          {this.context.orderSummary != ""
                                            ? this.context.orderSummary
                                                .orderPrepare
                                            : ""}
                                        </Badge>
                                      </Col>
                                    </Row>
                                  </Nav.Link>
                                </ListGroup.Item>
                              </>
                            )}

                            <ListGroup.Item>
                              <Nav.Link
                                as={Link}
                                to="/Package"
                                hidden={this.context.hidePackaingToolbarIcon()}
                              >
                                <Row>
                                  <Col>3. Package</Col>
                                  <Col className="text-end">
                                    <BsFillBagFill size="20" />
                                    <Badge
                                      bg="danger"
                                      className="notify-badge-right1 text-white"
                                    >
                                      {this.context.orderSummary != ""
                                        ? this.context.orderSummary.orderPackage
                                        : ""}
                                    </Badge>
                                  </Col>
                                </Row>
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item>
                              <Nav.Link
                                as={Link}
                                to="/Dispatch"
                                hidden={this.context.hideShippingToolbarIcon()}
                              >
                                <Row>
                                  <Col>4. Ship</Col>
                                  <Col className="text-end">
                                    <BsTruck size="20" />
                                    <Badge
                                      bg="danger"
                                      className="notify-badge-right1 text-white"
                                    >
                                      {this.context.orderSummary != ""
                                        ? this.context.orderSummary.orderShip
                                        : ""}
                                    </Badge>
                                  </Col>
                                </Row>
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item>
                              <Nav.Link
                                as={Link}
                                to="/Delivery"
                                hidden={this.context.hideDeliveryToolbarIcon()}
                              >
                                <Row>
                                  <Col>5. Delivery</Col>
                                  <Col className="text-end">
                                    <img
                                      width="26px"
                                      height="26px"
                                      // className="invertimage"
                                      style={{
                                        objectFit: "contain",
                                        color: "white",
                                      }}
                                      src="images/delivery.png"
                                    />
                                    <Badge
                                      bg="danger"
                                      className="notify-badge-right1 text-white"
                                    >
                                      {this.context.orderSummary != ""
                                        ? this.context.orderSummary
                                            .orderDelivery
                                        : ""}
                                    </Badge>
                                  </Col>
                                </Row>
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item>
                              <Nav.Link
                                as={Link}
                                to="/Payment"
                                hidden={this.context.hidePaymentToolbarIcon()}
                              >
                                <Row>
                                  <Col>6. Payment</Col>
                                  <Col className="text-end">
                                    <BsCashCoin size="20" />
                                    <Badge
                                      bg="danger"
                                      className="notify-badge-right1 text-white"
                                    >
                                      {this.context.orderSummary != ""
                                        ? this.context.orderSummary.orderPayment
                                        : ""}
                                    </Badge>
                                  </Col>
                                </Row>
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item>
                              <Nav.Link
                                as={Link}
                                to="/CloseOrder"
                                hidden={this.context.hideClosedOrders()}
                              >
                                <Row>
                                  <Col>7. Closed</Col>
                                  <Col className="text-end">
                                    <BsDoorClosed size="20" />
                                    <Badge
                                      bg="warning"
                                      className="notify-badge-right1 text-white"
                                    >
                                      {this.context.orderSummary != ""
                                        ? this.context.orderSummary.orderClose
                                        : ""}
                                    </Badge>
                                  </Col>
                                </Row>
                              </Nav.Link>
                            </ListGroup.Item>

                            <ListGroup.Item>
                              <Nav.Link
                                as={Link}
                                to="/OrderHistory"
                                hidden={this.context.hideClosedOrders()}
                              >
                                <Row>
                                  <Col>8. History</Col>
                                  <Col className="text-end">
                                    <BsClockHistory size="14" />
                                    <Badge
                                      bg="secondary"
                                      className="notify-badge-right1 text-white"
                                    >
                                      {this.context.orderSummary != ""
                                        ? this.context.orderSummary.orderHistory
                                        : ""}
                                    </Badge>
                                  </Col>
                                </Row>
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item>
                              <Nav.Link
                                as={Link}
                                to="/Returns"
                                hidden={this.context.hideReturns()}
                              >
                                <Row>
                                  <Col>9. Returns</Col>
                                  <Col className="text-end">
                                    <BsArrowReturnLeft size="20" />
                                    <Badge
                                      bg="danger"
                                      className="notify-badge-right1 text-white"
                                    >
                                      {this.context.orderSummary != ""
                                        ? this.context.orderSummary
                                            .orderReturned
                                        : ""}
                                    </Badge>
                                  </Col>
                                </Row>
                              </Nav.Link>
                            </ListGroup.Item>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </ListGroup.Item>
                  </>
                ) : (
                  <></>
                )}

                {/* Sales */}
                {this.showSales() ? (
                  <>
                    {this.context.storeSettings.showSalesModule == true ||
                    this.context.storeSettings.showSalesModule == undefined ? (
                      <>
                        <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                          <Accordion
                            defaultActiveKey="1"
                            className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                          >
                            <Accordion.Item
                              eventKey={
                                this.context.selectedMenuItem === "sales"
                                  ? "1"
                                  : "0"
                              }
                              className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                              onClick={(e) => {
                                this.context.selectedMenuItem = "sales";
                              }}
                            >
                              <Accordion.Header className="py-2  text-start">
                                <Nav.Link to="" className="m-0 p-0 fs-3 ">
                                  <BsFillCartCheckFill size="20" />
                                  {/* <FcSalesPerformance size="20" /> */}
                                  {/* <i class="bi bi-basket"></i> */}
                                  &nbsp;Sales
                                </Nav.Link>
                              </Accordion.Header>
                              <Accordion.Body>
                                {this.context.storeSettings.showLeadsModule ==
                                  true ||
                                this.context.storeSettings.showLeadsModule ==
                                  undefined ? (
                                  <>
                                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                      <Nav.Link as={Link} to="/SalesLeads">
                                        <FaBuysellads size={20} />
                                        &nbsp;Leads Management
                                      </Nav.Link>
                                    </ListGroup.Item>
                                  </>
                                ) : (
                                  <></>
                                )}

                                {this.context.storeSettings.showQuoteModule ==
                                  true ||
                                this.context.storeSettings.showQuoteModule ==
                                  undefined ? (
                                  <>
                                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                      <Nav.Link
                                        as={Link}
                                        to="/QuotationRequest"
                                      >
                                        <BiSolidQuoteRight size="20" />
                                        &nbsp;Quotation Orders(QO)
                                      </Nav.Link>
                                    </ListGroup.Item>
                                  </>
                                ) : (
                                  <></>
                                )}
                                {this.context.storeSettings.showPosmodule ==
                                  true ||
                                this.context.storeSettings.showPosmodule ==
                                  undefined ? (
                                  <>
                                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                      <Nav.Link as={Link} to="/SalesOrders">
                                        {/* <RiCoupon5Line size="20" /> */}
                                        <PiListNumbersFill size="20" />
                                        &nbsp;Sale Orders(SO)
                                      </Nav.Link>
                                    </ListGroup.Item>
                                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                      <Nav.Link
                                        as={Link}
                                        to={
                                          "https://" +
                                          this.context.store.storePosDomainName
                                        }
                                        target="_blank"
                                      >
                                        <FaMoneyBillTrendUp size="20" />
                                        &nbsp;Billing POS - OUTWARD
                                      </Nav.Link>
                                    </ListGroup.Item>
                                  </>
                                ) : (
                                  <></>
                                )}

                                {this.context.storeSettings
                                  .showEcommerceModule == true ||
                                this.context.storeSettings
                                  .showEcommerceModule == undefined ? (
                                  <>
                                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                      <Nav.Link
                                        as={Link}
                                        to={
                                          "https://" +
                                          this.context.store.storeDomainName
                                        }
                                        target="_blank"
                                      >
                                        <SiCommerzbank size="20" />
                                        &nbsp;ECommerce / OnlineStore
                                      </Nav.Link>
                                    </ListGroup.Item>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </ListGroup.Item>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}

                {/* RawMaterials Inventory*/}
                {this.showRmInventory() &&
                (this.context.storeSettings.isManufacturer == true ||
                  this.context.storeSettings.isServiceManagementBusiness ==
                    true) ? (
                  <>
                    <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                      <Accordion
                        defaultActiveKey="1"
                        className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                      >
                        <Accordion.Item
                          eventKey={
                            this.context.selectedMenuItem === "kitchen"
                              ? "1"
                              : "0"
                          }
                          className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                          onClick={(e) => {
                            this.context.selectedMenuItem = "kitchen";
                          }}
                        >
                          <Accordion.Header className="py-2  text-start">
                            <Nav.Link as={Link} to="" className="m-0 p-0 fs-3">
                              {/* <TbPackage size="20"></TbPackage> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-boxes"
                                viewBox="0 0 16 16"
                              >
                                <path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434zM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567zM7.5 9.933l-2.75 1.571v3.134l2.75-1.571zm1 3.134 2.75 1.571v-3.134L8.5 9.933zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567zm2.242-2.433V3.504L8.5 5.076V8.21zM7.5 8.21V5.076L4.75 3.504v3.134zM5.258 2.643 8 4.21l2.742-1.567L8 1.076zM15 9.933l-2.75 1.571v3.134L15 13.067zM3.75 14.638v-3.134L1 9.933v3.134z" />
                              </svg>
                              {this.context.store.businessTypeId == 3 ? (
                                <>&nbsp;RawMaterials </>
                              ) : (
                                <>&nbsp;RawMaterials </>
                              )}
                            </Nav.Link>
                          </Accordion.Header>
                          <Accordion.Body>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                              <Nav.Link as={Link} to="/RawMaterialCategory">
                                <RiCoupon5Line size="20" />
                                &nbsp;RM Categories
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                              <Nav.Link as={Link} to="/RawMaterialIndent">
                                <RiCoupon5Line size="20" />
                                &nbsp;RM Purchase Order[INDENT]
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                              <Nav.Link as={Link} to="/RawMaterialInward">
                                <RiCoupon5Line size="20" />
                                &nbsp;RM Purchase Order[INWARD]
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                              <Nav.Link as={Link} to="/RawMaterialsInventory">
                                <RiCoupon5Line size="20" />
                                &nbsp;RM Inventory
                              </Nav.Link>
                            </ListGroup.Item>

                            {this.context.store.businessTypeId == 3 ? (
                              <></>
                            ) : (
                              <>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                  <Nav.Link
                                    as={Link}
                                    to="/RawMaterialManufacturingRequest"
                                  >
                                    <RiCoupon5Line size="20" />
                                    &nbsp;Production Requests
                                  </Nav.Link>
                                </ListGroup.Item>

                                {this.context.storeSettings
                                  .isServiceManagementBusiness == true ? (
                                  <>
                                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                      <Nav.Link
                                        as={Link}
                                        to="/RawMaterialServiceRequest"
                                      >
                                        <RiCoupon5Line size="20" />
                                        &nbsp;Servicing Requests
                                      </Nav.Link>
                                    </ListGroup.Item>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </>
                            )}
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                              <Nav.Link as={Link} to="/RawMaterialsOutOfStock">
                                <RiCoupon5Line size="20" />
                                &nbsp;In-Stock Checker
                              </Nav.Link>
                            </ListGroup.Item>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </ListGroup.Item>
                  </>
                ) : (
                  <></>
                )}

                {/* Manufacture */}
                {this.showManufacturer() ? (
                  <>
                    {this.context.storeSettings.isManufacturer == true ? (
                      <>
                        <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                          <Accordion
                            defaultActiveKey="1"
                            className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                          >
                            <Accordion.Item
                              eventKey={
                                this.context.selectedMenuItem === "manufacture"
                                  ? "1"
                                  : "0"
                              }
                              className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                              onClick={(e) => {
                                this.context.selectedMenuItem = "manufacture";
                              }}
                            >
                              <Accordion.Header className="py-2  text-start">
                                <Nav.Link to="" className="m-0 p-0 fs-3 ">
                                  {this.context.store.businessTypeId == 3 ? (
                                    <>
                                      <MdSoupKitchen size="20" />
                                      &nbsp;Kitchen{" "}
                                    </>
                                  ) : (
                                    <>
                                      <FcWorkflow size="20" />
                                      &nbsp;Production
                                    </>
                                  )}
                                </Nav.Link>
                              </Accordion.Header>
                              <Accordion.Body className="text-secondary">
                                {this.context.store.businessTypeId == 3 ? (
                                  <></>
                                ) : (
                                  <>
                                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                      <Nav.Link
                                        as={Link}
                                        to="/ManufacturingRequestOrders"
                                      >
                                        <RiCoupon5Line size="20" />
                                        &nbsp;Production Orders
                                      </Nav.Link>
                                    </ListGroup.Item>
                                    <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                      <Nav.Link
                                        as={Link}
                                        to="/ManufacturingTasks"
                                      >
                                        <RiCoupon5Line size="20" />
                                        &nbsp;Production Tasks
                                      </Nav.Link>
                                    </ListGroup.Item>
                                  </>
                                )}

                                <ListGroup.Item className="px-0 py-2 mx-0 my-0 ">
                                  <Nav.Link as={Link} to="/Recipes">
                                    <RiCoupon5Line size="20" />
                                    {this.context.store.businessTypeId == 3 ? (
                                      <>&nbsp;Recipes & Estimation</>
                                    ) : (
                                      <>
                                        &nbsp;Product Costing & Making
                                        Procedures
                                      </>
                                    )}
                                  </Nav.Link>
                                </ListGroup.Item>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </ListGroup.Item>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}

                {/* Product Inventory */}
                {this.showProductInventory() ? (
                  <>
                    {this.context.storeSettings.showProductInventoryModule ==
                      true ||
                    this.context.storeSettings.showProductInventoryModule ==
                      undefined ? (
                      <>
                        <ListGroup.Item className="px-0 py-0 m-0 ">
                          <Accordion
                            defaultActiveKey="1"
                            className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                          >
                            <Accordion.Item
                              eventKey={
                                this.context.selectedMenuItem === "product"
                                  ? "1"
                                  : "0"
                              }
                              className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                              onClick={(e) => {
                                e.eventKey = "1";
                                this.context.selectedMenuItem = "product";
                                //this.context.UpdateSelectedMenuItem("product");
                              }}
                            >
                              <Accordion.Header className="py-2 text-start">
                                <Nav.Link
                                  as={Link}
                                  to=""
                                  className="m-0 p-0 fs-3 "
                                  onClick={(e) =>
                                    this.setState({
                                      productDefaultActiveKey: 0,
                                    })
                                  }
                                >
                                  {/* <BsCardList size="20" /> */}
                                  <TbPackages size="20"></TbPackages>
                                  &nbsp;Products
                                </Nav.Link>
                              </Accordion.Header>
                              <Accordion.Body>
                                <ListGroup variant="flush" className="bg-black">
                                  <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                    <Nav.Link as={Link} to="/Category">
                                      <BsDiagram3 size="20" />
                                      &nbsp;Product Category
                                    </Nav.Link>
                                  </ListGroup.Item>
                                  <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                    <Nav.Link as={Link} to="/ProductIndent">
                                      <RiCoupon5Line size="20" />
                                      &nbsp;Purchase INDENT
                                    </Nav.Link>
                                  </ListGroup.Item>
                                  <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                    <Nav.Link as={Link} to="/ProductInward">
                                      <RiCoupon5Line size="20" />
                                      &nbsp;Purchase INWARD
                                    </Nav.Link>
                                  </ListGroup.Item>
                                  <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                    <Nav.Link as={Link} to="/Product">
                                      <BsUiChecksGrid size="20" />
                                      &nbsp;Product Inventory
                                    </Nav.Link>
                                  </ListGroup.Item>
                                  <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                    <Nav.Link as={Link} to="/OutOfStock">
                                      <BsZoomOut size="20" />
                                      &nbsp;In-Stock Checker
                                    </Nav.Link>
                                  </ListGroup.Item>

                                  <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                    <Nav.Link as={Link} to="/Brands">
                                      <BsAward size="20" />
                                      &nbsp;Brands
                                    </Nav.Link>
                                  </ListGroup.Item>
                                  <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                    <Nav.Link as={Link} to="/DataTypes">
                                      <SiDatabricks size="20" />
                                      &nbsp;DataTypes
                                    </Nav.Link>
                                  </ListGroup.Item>

                                  {this.context.storeSettings
                                    .showEcommerceModule == true ||
                                  this.context.storeSettings
                                    .showEcommerceModule == undefined ? (
                                    <>
                                      <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                        <Nav.Link as={Link} to="/ProductGroups">
                                          <BsBoundingBox size="20" />
                                          &nbsp;Product Groups
                                        </Nav.Link>
                                      </ListGroup.Item>
                                    </>
                                  ) : (
                                    <></>
                                  )}

                                  <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                    <Nav.Link as={Link} to="/BarCodeCustom">
                                      <BsFillCameraFill size="20" />
                                      &nbsp;BarCode Creator
                                    </Nav.Link>
                                  </ListGroup.Item>
                                </ListGroup>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </ListGroup.Item>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}

                {/* Servicing */}
                {this.showServicing() ? (
                  <>
                    {this.context.storeSettings.isServiceManagementBusiness ==
                    true ? (
                      <>
                        <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                          <Accordion
                            defaultActiveKey="1"
                            className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                          >
                            <Accordion.Item
                              eventKey={
                                this.context.selectedMenuItem === "servicing"
                                  ? "1"
                                  : "0"
                              }
                              className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                              onClick={(e) => {
                                this.context.selectedMenuItem = "servicing";
                              }}
                            >
                              <Accordion.Header className="py-2  text-start">
                                <Nav.Link to="" className="m-0 p-0 fs-3 ">
                                  <GrServices size="20" />
                                  {this.context.store.businessTypeId == 3 ? (
                                    <></>
                                  ) : (
                                    <>&nbsp;Servicing</>
                                  )}
                                </Nav.Link>
                              </Accordion.Header>
                              <Accordion.Body>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link
                                    as={Link}
                                    to="/ProductServiceCustomers"
                                  >
                                    <RiCoupon5Line size="20" />
                                    &nbsp;Customers DB
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link
                                    as={Link}
                                    to="/ProductServiceBookings"
                                  >
                                    <RiCoupon5Line size="20" />
                                    &nbsp;Service Booking
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link
                                    as={Link}
                                    to="/ProductServiceTaskInventory"
                                  >
                                    <RiCoupon5Line size="20" />
                                    <>&nbsp;Serivicing Tasks Inventory</>
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link
                                    as={Link}
                                    to="/ProductServiceRequests"
                                  >
                                    <RiCoupon5Line size="20" />
                                    &nbsp;Servicing Order
                                  </Nav.Link>
                                </ListGroup.Item>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </ListGroup.Item>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}

                {/* CRM */}
                {this.showCrm() ? (
                  <>
                    <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                      <Accordion
                        defaultActiveKey="1"
                        className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                      >
                        <Accordion.Item
                          eventKey={
                            this.context.selectedMenuItem === "customer"
                              ? "1"
                              : "0"
                          }
                          className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                          onClick={(e) => {
                            this.context.selectedMenuItem = "customer";
                          }}
                        >
                          <Accordion.Header className="py-2  text-start">
                            <Nav.Link className="m-0 p-0 fs-3" as={Link} to="">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-person-bounding-box"
                                viewBox="0 0 16 16"
                              >
                                <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5" />
                                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                              </svg>
                              &nbsp;Customers(CRM)
                            </Nav.Link>
                          </Accordion.Header>
                          <Accordion.Body>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link as={Link} to="/Customers">
                                <BsPeopleFill size="20" />
                                &nbsp;Customer DB
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link as={Link} to="/Coupon">
                                <RiCoupon5Line size="20" />
                                &nbsp;Coupons
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link
                                as={Link}
                                to="/Feedbacks"
                                disabled={true}
                              >
                                <RiCoupon5Line size="20" />
                                &nbsp;Feedbacks & Ratings
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link
                                as={Link}
                                to="/Complaints"
                                disabled={true}
                              >
                                <RiCoupon5Line size="20" />
                                &nbsp;Complaints & Issues
                              </Nav.Link>
                            </ListGroup.Item>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </ListGroup.Item>
                  </>
                ) : (
                  <></>
                )}

                {/* HRM */}
                {this.showHrm() ? (
                  <>
                    {this.context.storeSettings.showHrmModule == true ? (
                      <>
                        <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                          <Accordion
                            defaultActiveKey="1"
                            className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                          >
                            <Accordion.Item
                              eventKey={
                                this.context.selectedMenuItem === "hrm"
                                  ? "1"
                                  : "0"
                              }
                              className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                              onClick={(e) => {
                                this.context.selectedMenuItem = "hrm";
                              }}
                            >
                              <Accordion.Header className="py-2  text-start">
                                <Nav.Link
                                  as={Link}
                                  to=""
                                  className="m-0 p-0 fs-3"
                                >
                                  <FaUsers size={22} />
                                  &nbsp;Employees (HRM)
                                </Nav.Link>
                              </Accordion.Header>
                              <Accordion.Body>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/Departments">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Departments
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/Employees">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Employee DB
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/EmployeeTimesheet">
                                    <RiCoupon5Line size="20" />
                                    &nbsp;Employee Timesheet
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/EmployeeAbsence">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Employee Leave
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/EmployeeActions">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Employee Actions
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/EmployeeRequests">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Employee Requests
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/EmployeePerformance">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Employee Performance
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/Employees">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Employee Onboarding
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/Employees">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Employee Exit/Resign
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link
                                    as={Link}
                                    to="/EmployeeHolidayCalendar"
                                  >
                                    <RiCoupon5Line size="20" />
                                    &nbsp;Holidays Calender
                                  </Nav.Link>
                                </ListGroup.Item>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </ListGroup.Item>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}

                {/* Projects */}
                {this.showProjects() ? (
                  <>
                    {this.context.storeSettings.showFinanceModule == true ? (
                      <>
                        <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                          <Accordion
                            defaultActiveKey="1"
                            className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                          >
                            <Accordion.Item
                              eventKey={
                                this.context.selectedMenuItem === "project"
                                  ? "1"
                                  : "0"
                              }
                              className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                              onClick={(e) => {
                                this.context.selectedMenuItem = "project";
                              }}
                            >
                              <Accordion.Header className="py-2  text-start">
                                <Nav.Link
                                  as={Link}
                                  to=""
                                  className="m-0 p-0 fs-3"
                                >
                                  <FaProjectDiagram size="20" />
                                  &nbsp;Projects
                                </Nav.Link>
                              </Accordion.Header>
                              <Accordion.Body>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/ProjectManagement">
                                    <FaProjectDiagram size="20" />
                                    &nbsp;Projects
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/ProjectTasks">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Project WorkItems
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link
                                    as={Link}
                                    disabled
                                    to="/ProjectTasks"
                                  >
                                    <BsPeopleFill size="20" />
                                    &nbsp;Project Backlogs
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/ProjectRisks">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Project Risks
                                  </Nav.Link>
                                </ListGroup.Item>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </ListGroup.Item>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}

                {/* Accounts */}
                {this.showAccounts() ? (
                  <>
                    {this.context.storeSettings.showFinanceModule == true ? (
                      <>
                        <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                          <Accordion
                            defaultActiveKey="1"
                            className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                          >
                            <Accordion.Item
                              eventKey={
                                this.context.selectedMenuItem === "account"
                                  ? "1"
                                  : "0"
                              }
                              className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                              onClick={(e) => {
                                this.context.selectedMenuItem = "account";
                              }}
                            >
                              <Accordion.Header className="py-2  text-start">
                                <Nav.Link
                                  as={Link}
                                  to=""
                                  className="m-0 p-0 fs-3"
                                >
                                  <BsCashCoin size={20} />
                                  &nbsp;Accounting
                                </Nav.Link>
                              </Accordion.Header>
                              <Accordion.Body>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/AccountingDashboard">
                                    <MdDashboard size={20} />
                                    &nbsp;Dashboard
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link
                                    as={Link}
                                    to="/AccountExpensesCategorys"
                                  >
                                    <BsPeopleFill size="20" />
                                    &nbsp;Account Category
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/AccountExpenses">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Debits [Expenses/Outflows]
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/AccountRevenues">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Credits [Revenues/Inflows]
                                  </Nav.Link>
                                </ListGroup.Item>

                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/AccountReceiveables">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Receivable (AR)
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/AccountPayables">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Payable (AP)
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/AccountPayroll">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Employee Payroll
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link
                                    as={Link}
                                    to="/BankAccountManagement"
                                  >
                                    <BsPeopleFill size="20" />
                                    &nbsp;Bank Accounts
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/BankRecoPage">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Bank Reconciliation
                                  </Nav.Link>
                                </ListGroup.Item>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/AccountLedger">
                                    <BsPeopleFill size="20" />
                                    &nbsp;Ledger
                                  </Nav.Link>
                                </ListGroup.Item>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </ListGroup.Item>
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}

                {/* Admin */}
                {this.ShowAdminMenu() ? (
                  <>
                    <ListGroup.Item className="px-0 py-0 mx-0 my-0">
                      <Accordion
                        defaultActiveKey="1"
                        className="mx-0 px-0 py-0 my-0 mb-0 border-0"
                      >
                        <Accordion.Item
                          eventKey={
                            this.context.selectedMenuItem === "admin"
                              ? "1"
                              : "0"
                          }
                          className="border-0 mx-0 px-0 py-0 my-0 mb-0"
                          onClick={(e) => {
                            this.context.selectedMenuItem = "admin";
                          }}
                        >
                          <Accordion.Header className="mx-0 p-lg-0  text-start">
                            <Nav.Link as={Link} to="" className="m-0 p-0 fs-3">
                              <BsPersonSquare size="20" />
                              &nbsp;Admin Settings
                            </Nav.Link>
                          </Accordion.Header>
                          <Accordion.Body>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link as={Link} to="/Users">
                                <BsPersonCheckFill size="20" />
                                &nbsp;Admin Portal Users
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link as={Link} to="/PosUsers">
                                <BsPersonCheckFill size="20" />
                                &nbsp;POS Portal Users
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link as={Link} to="/ShippingConfig">
                                <BsTruck size="20" />
                                &nbsp;Shipping / Delivery
                              </Nav.Link>
                            </ListGroup.Item>
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link as={Link} to="/TaxesConfig">
                                <TbReceiptTax size="20" />
                                &nbsp;Taxes
                              </Nav.Link>
                            </ListGroup.Item>
                            {this.context.store.businessTypeId == 3 ? (
                              <>
                                <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                                  <Nav.Link as={Link} to="/RestaurantTables">
                                    <TbReceiptTax size="20" />
                                    &nbsp;Retaurant Tables
                                  </Nav.Link>
                                </ListGroup.Item>
                              </>
                            ) : (
                              ""
                            )}
                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link as={Link} to="/MultiCurrencys">
                                <TbReceiptTax size="20" />
                                &nbsp;Multi Country & Currency Settings
                              </Nav.Link>
                            </ListGroup.Item>

                            <ListGroup.Item className="px-0 py-2 mx-0 my-0">
                              <Nav.Link as={Link} to="/StoreSettings">
                                <TbBuildingStore size="20" />
                                &nbsp;Settings
                              </Nav.Link>
                            </ListGroup.Item>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </ListGroup.Item>
                  </>
                ) : (
                  <></>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </>
    );
  }
}
